$(document).ready(function () {
var checkSlider = setInterval(function () {
$(".featured-collection-slider").slick({
    infinite: false,
    arrows: true,
    rows: 1,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          infinite: false,
          slidesToShow: 2,
          rows: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          infinite: false,
          slidesToShow: 2,
          rows: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
    },100);
    setTimeout(function () {
    clearInterval(checkSlider); // Clear the interval
}, 200);
    $(".custom-tabs-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".tabs").find("li:eq(0)").addClass("active");
  $("#tabs-1").nextAll().hide();

  $(".tabs li").click(function (e) {
    e.preventDefault();
    var er = $(this).find("a").attr("data-id");
    $(".tabs li").removeClass("active");
    $(this).addClass("active");
    var index = $(".tabs li").index(this);
    
    // Hide all tab contents and show the selected one
    $(".tab-contents").hide();
    $(".tab-contents:eq(" + index + ")").show();
    
    // Refresh Slick Slider within the selected tab content
    $(".tab-contents:eq(" + index + ")").find(".featured-collection-slider").slick("refresh");
  });

  // Optionally, adjust the timeout if needed
  setTimeout(function() {
    $('.oke-sr-total-text').text(function(index, text) {
      return text.replace(/ Reviews?/g,'');
    });
  }, 1400);
});

